import React, { ReactNode } from 'react';
import { useCollapse } from 'react-collapsed';
import styled from 'styled-components';
import KubitTooltip from '../KubitTooltip';
import { IconWrapper, SvgIcon } from '../Icon';
import { IExpandableTableItem } from './types';
import { theme } from '../../styles/theme';

interface IProps {
  children: ReactNode;
  table: IExpandableTableItem;
}

const SectionTitle = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: 4px 12px 4px 16px;
  background-color: ${theme.colors.tableHeader};
  color: ${theme.colors.secondary800};
  outline: none;
  &:hover {
    color: ${theme.colors.mainBlue};
    cursor: pointer;
  }
`;
const TitleContainer = styled.div`
  display: grid;
  grid-template-columns: 342px 342px;
  font-size: 12px;
  font-weight: 600;
  color: ${theme.colors.secondary900};
`;
const Content = styled.div`
  border-top: 1px solid ${theme.colors.border};
`;

const ExpandableTableSection = ({ children, table }: IProps) => {
  const { getCollapseProps, getToggleProps, isExpanded } = useCollapse({
    defaultExpanded: false,
  });

  return (
    <div>
      <SectionTitle {...getToggleProps()}>
        <TitleContainer>
          <span>{table.title}</span>
          {table.secondColumnTitle && <span>{table.secondColumnTitle}</span>}
        </TitleContainer>
        <KubitTooltip
          content={isExpanded ? 'Fold the Section' : 'Expand the Section'}
          noOpenDelay={true}
        >
          <IconWrapper size={12}>
            <SvgIcon
              name={isExpanded ? 'table-collapse' : 'table-expand'}
              width={8}
              height={12}
              customFill="currentColor"
            />
          </IconWrapper>
        </KubitTooltip>
      </SectionTitle>
      <Content {...getCollapseProps()}>{children}</Content>
    </div>
  );
};

export default ExpandableTableSection;
